/**
 * Дефолтная модальность для подбора практик (interventions), если у пользователя
 * нет прохождения опросника модальностей. Не участвует в опроснике и не показывается
 * в результатах профиля для этого опросника.
 */
export const INTERVENTION_DEFAULT_MODALITY_CODE = 'applied' as const;

export function isModalityExcludedFromQuestionnaireUi(code: string | undefined): boolean {
  return code === INTERVENTION_DEFAULT_MODALITY_CODE;
}
